{
  "title": "Disclaimer",
  "sections": [
    {
      "heading": { "level": 2, "title": "No Investment or Professional Advice" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "The information provided on PredictionHero is for informational and educational purposes only and does not constitute investment advice, financial advice, trading advice, legal advice, or any other form of professional advice."
        },
        {
          "type": "paragraph",
          "text": "PredictionHero does not recommend that any asset, contract, position, or outcome be bought, sold, traded, or held. You are solely responsible for your decisions and actions. Always conduct your own research and consult qualified professionals before making decisions involving financial or legal risk."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Accuracy of Information" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "PredictionHero strives to present data accurately and in good faith. However, we make no representations or warranties regarding the accuracy, completeness, timeliness, or reliability of any information displayed on the platform."
        },
        {
          "type": "paragraph",
          "text": "All information is provided “as is” and “as available.” You understand and agree that you use the Services and rely on any information at your own risk."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Informational Signals Only" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "PredictionHero aggregates and analyzes publicly available and third-party data to surface informational signals, trends, and summaries. These signals are descriptive, not predictive, and should not be interpreted as recommendations, forecasts, or guarantees of future outcomes."
        },
        {
          "type": "paragraph",
          "text": "Past or historical data does not guarantee future results."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Non-Endorsement of Third Parties" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "References to third-party platforms, markets, data providers, products, services, or links do not constitute an endorsement, recommendation, warranty, or guarantee by PredictionHero."
        },
        {
          "type": "paragraph",
          "text": "PredictionHero is not affiliated with, endorsed by, or sponsored by any prediction market, exchange, or third-party provider unless explicitly stated. Users should perform their own due diligence before engaging with any third-party services."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Third-Party Data and Sources" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "Some content displayed on PredictionHero is derived from third-party sources. Ownership and responsibility for such data remain with the respective providers. PredictionHero does not control these sources and makes no guarantees regarding their accuracy or availability."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Prediction Markets Risk Disclosure" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "Prediction markets are speculative and involve material risk, including the potential loss of funds. Outcomes may be influenced by incomplete information, market behavior, regulatory changes, or unforeseen events."
        },
        {
          "type": "paragraph",
          "text": "Prediction markets and related products may be restricted or unlawful in certain jurisdictions. Users are responsible for understanding and complying with all applicable laws and regulations in their jurisdiction."
        },
        {
          "type": "paragraph",
          "text": "PredictionHero does not facilitate participation in prediction markets."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "AI-Generated and Automated Content" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "Some content, summaries, or analyses on PredictionHero may be generated or assisted by automated or AI-based systems. Such content may be incomplete, inaccurate, or outdated and should not be relied upon as factual or professional advice."
        },
        {
          "type": "paragraph",
          "text": "Use of AI-generated content is at your own risk."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Limitation of Liability" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "To the maximum extent permitted by law, PredictionHero shall not be liable for any losses or damages—direct or indirect—arising from your use of the platform, reliance on any information provided, or interaction with third-party services."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Jurisdictional Responsibility" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "You are solely responsible for determining whether your use of the Services complies with applicable laws in your jurisdiction. PredictionHero makes no representation that the Services are appropriate or available for use in all locations."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Changes to This Disclaimer" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "PredictionHero may update this Disclaimer at any time. Continued use of the Services constitutes acceptance of the revised Disclaimer."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "Important Note" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "PredictionHero does not estimate, simulate, or invent probabilities."
        },
        {
          "type": "paragraph",
          "text": "All probabilities, pricing, and market activity displayed on the platform originate from external prediction market platforms and their users."
        }
      ]
    }
  ]
}
